export const props = { viewBox: "0 0 20 20" };
export const innerHTML = "<circle cx=3 cy=10 r=1.5 /><circle cx=10 cy=10 r=1.5 /><circle cx=17 cy=10 r=1.5 />";
